import { createContext } from "react";
import type { GymProfile, ProfileInput } from "../types/gym.types";

export interface ProfileState {
  profile: GymProfile | null;
  isLoading: boolean;
  error: string | null;
  /** true once a completed profile exists — the gate for booking. */
  isComplete: boolean;
  refresh: () => Promise<void>;
  /** Saves via the API and updates this shared state on success. */
  save: (input: ProfileInput) => Promise<GymProfile>;
}

export const ProfileContext = createContext<ProfileState | undefined>(undefined);
